module.exports = __webpack_public_path__ + "static/media/ff_cloud_agents.5083dd56.png";